const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllWho5() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/who5`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getWho5ByID(postId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/who5/${postId}`, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${ authToken }`,
        },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllWho5ByTax(taxId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(
      `${API_URL}/who5?tratamiento=${taxId}&per_page=99`,
      {
        method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}
